import { queryOptions, useQuery } from "@tanstack/react-query";
import { getAuthzContext } from "connect-api/authz/api/get-authz-context";

import { typedFetchNoImpersonate } from "~/api/typed-fetch";

const authzContextQueryOptions = {
  all: () => ["authz"] as const,
  current: () =>
    queryOptions({
      queryKey: [...authzContextQueryOptions.all(), "current"] as const,
      queryFn: ({ signal }) => getAuthzContext(typedFetchNoImpersonate, signal),
      staleTime: Infinity,
    }),
};

interface UseAuthzContextOptions {
  enabled: boolean;
}

function useAuthzContext({ enabled }: UseAuthzContextOptions) {
  return useQuery({ ...authzContextQueryOptions.current(), enabled });
}

export { authzContextQueryOptions, useAuthzContext };
